import React from 'react';
import {connect} from 'react-redux';
import spinner from './../Spinnerimage.gif';
import {OnRefreshPageLoad,OnRefreshPageCancel} from './../components/SiteCat/SiteCat'
import AxiosDataService from '../services/AxiosDataService';
import {onUserCancel} from '../constants/merchantData';

class errorpage extends React.Component{
constructor() {
    super();

    this.state = {
      merchantName:"",
      isLoaded: false,
    };
  }

  componentWillMount() {
    const pathNameData = window.location.pathname;
    const merchantName =  pathNameData.split(':')[1];
      this.setState({
          merchantName: merchantName
    });
    
  }
  componentDidMount() {
    const pathName =window.location.pathname;
    const validMerchant = pathName.split(":")[1];
    const options={
      url: window.location.origin + '/web/cardissuer/accntlinking/cancelUrl/' + validMerchant,
      method: 'get',
      flag:'app'
    }
    AxiosDataService.fetch(options).then(response => {
      this.setState({
          cancelUrl: response.data.cancelUrl,
          merchantName : validMerchant
      });
    }); 
    OnRefreshPageLoad(this.state.merchantName);
  }

  continueWithMechant = event =>{
    OnRefreshPageCancel(this.state.merchantName);
    console.log(this.state.merchantName + "merchant4")
    this.setState({
      isLoaded: true,
    })
    let data = {
      merchantName: this.state.merchantName,
      cancelUrlData: this.state.cancelUrl
    }
    onUserCancel(data);
 }


  render() {
    let isLoadervalue = this.state.isLoaded;
    return(
        <React.Fragment>
        {isLoadervalue ?
        <div className="spinner">
        <img src={spinner} alt="Spinner"/>
        </div> : null
        }
        <div className="row">
            <div className="col-xs-12 col-sm-8 col-md-8 col-lg-4 col-md-offset-2 col-lg-offset-4 col-sm-offset-2">
              <div className="tech-diff-header">Let's try again</div>
              <div className="tech-diff-section">It looks like you refreshed your browser, so your action was canceled. Please click "Continue" to try again.</div>
       
            </div>
          </div>
          <div className="row">
            <div className="alreadylink-blk col-xs-12 col-sm-8 col-md-7 col-lg-3 col-md-offset-2 col-lg-offset-4 col-sm-offset-2">
            <div className="row alreadylink-btn">
             <button onClick={this.continueWithMechant}>Continue</button>
            </div>
            </div>
        </div>
          </React.Fragment>
      
     
    );
  }
}

const mapStateToProps = (state) => {
  return {
    linkedposts: state
  }
}

export default connect(mapStateToProps)(errorpage);